import { FindingType, RenderableFindingBase } from "@kells/interfaces/finding";

/**
 * Brand palette for bounding boxes on intraoral photos and PDF exports.
 * Inner/outer strokes use the same hue (double-outline style).
 */
export const REPORT_FINDING_BOX_STROKE: Record<
  FindingType,
  { outer: string; inner: string }
> = {
  [FindingType.Caries]: { outer: "#C1121F", inner: "#C1121F" },
  [FindingType.Tooth]: { outer: "#a1a1a1", inner: "#a1a1a1" },
  [FindingType.Material]: { outer: "#6A4C93", inner: "#6A4C93" },
  [FindingType.Dummy]: { outer: "#a1a1a1", inner: "#a1a1a1" },
  [FindingType.BoneLoss]: { outer: "#5C677D", inner: "#5C677D" },
  [FindingType.Fracture]: { outer: "#F77F00", inner: "#F77F00" },
  [FindingType.Calculus]: { outer: "#D4A017", inner: "#D4A017" },
  [FindingType.Infection]: { outer: "#FF006E", inner: "#FF006E" },
  [FindingType.DefectiveRestoration]: { outer: "#008C8C", inner: "#008C8C" },
  [FindingType.Plaque]: { outer: "#7ED957", inner: "#7ED957" },
  [FindingType.GumRecession]: { outer: "#FF6F61", inner: "#FF6F61" },
  [FindingType.GumInflammation]: { outer: "#FF2D55", inner: "#FF2D55" },
  [FindingType.MissingTooth]: { outer: "#2979FF", inner: "#2979FF" },
};

export function getReportFindingBoxStroke(
  finding: RenderableFindingBase
): { outer: string; inner: string } {
  const entry = REPORT_FINDING_BOX_STROKE[finding.type];
  return entry ?? REPORT_FINDING_BOX_STROKE[FindingType.Caries];
}

/**
 * Default stroke colors for `koa-xray-image` getColor(category, default).
 * Keys include legacy Haleon overrides (cariesInitial, boneLossModerate, etc.).
 */
export const REPORT_XRAY_IMAGE_COLOR_DEFAULTS: Record<string, string> = {
  caries: "#C1121F",
  cariesInitial: "#C1121F",
  cariesModerate: "#C1121F",
  cariesAdvanced: "#C1121F",
  fracture: "#F77F00",
  plaque: "#7ED957",
  gumRecession: "#FF6F61",
  gumInflammation: "#FF2D55",
  missingTooth: "#2979FF",
  boneLoss: "#5C677D",
  boneLossModerate: "#5C677D",
  boneLossAdvanced: "#5C677D",
  material: "#6A4C93",
  calculus: "#D4A017",
  infection: "#FF006E",
  defectiveRestoration: "#008C8C",
};
